// @ts-nocheck
import { registerBlockType } from '@wordpress/blocks';
import Edit from './edit';

/* Load styles */
import './style.scss';   // frontend
import './editor.scss';  // editor

registerBlockType('zigaform/form-shortcode', {
	edit: Edit,
	save() {
		return null;
	},
});
